import {
  createStyles,
  Typography,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import React from "react";
import type { LivestockInfoFromFarm } from "shared/types";

type LotColumnCellProps = {
  row: LivestockInfoFromFarm;
  value: string | null;
} & WithStyles<typeof styles>;

function LotColumnCell({ classes, row, value }: LotColumnCellProps) {
  return (
    <div className={classes.root}>
      <Typography className={classes.value} component="span">
        {value ?? "-"}
      </Typography>
      <Typography className={classes.pasture} component="span">
        {row.pasture?.shortName ?? "-"}
      </Typography>
    </div>
  );
}

const styles = () =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      textTransform: "uppercase",
    },
    value: {
      fontWeight: "bold",
      color: "inherit",
      fontSize: "inherit",
    },
    pasture: { color: "inherit", fontSize: "inherit" },
  });

export default withStyles(styles)(LotColumnCell);
